import type ActiveDirectoryTokenDto from "~/models/ActiveDirectoryTokenDto";

export const useAuthModule = defineStore(
  "auth",
  () => {
    const authenticated = ref(false);
    const loggedInUser = ref("");
    const token = ref<ActiveDirectoryTokenDto | undefined>();

    async function setToken(tokenResponse: ActiveDirectoryTokenDto, loginUsername?: string) {
      if (loginUsername)
        loggedInUser.value = loginUsername;

      authenticated.value = true;
      AnybillLogger.setUser(loginUsername ?? "- missing -");

      await AnybillLogger.instance.info(`User logged in`, "auth store");
      token.value = { ...tokenResponse } as ActiveDirectoryTokenDto;
    }

    function logout() {
      // Clear all Pinia stores by resetting them
      const pinia = usePinia();

      // Reset all stores that support $reset
      // @ts-expect-error - accessing internal Pinia API to reset all stores
      pinia._s.forEach((store: { $reset?: () => void }) => {
        try {
          store.$reset?.();
        }
        catch {
          // Store uses setup syntax and doesn't implement $reset - skip it
        }
      });

      // Clear browser storage
      if (import.meta.client) {
        localStorage.clear();
        sessionStorage.clear();

        // Clear any cookies
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
      }

      // Reset auth store state
      reset();
    }

    function reset() {
      token.value = undefined;
      authenticated.value = false;
      loggedInUser.value = "";
      AnybillLogger.removeUser();
    }

    // TODO: refresh token mechanic is broken in backend
    // async function refreshToken(): Promise<boolean> {
    //   if (token.value?.refresh_token) {
    //     const refreshTokenResponse = await AuthProvider.Instance.refreshToken(token.value.refresh_token);

    //     if (refreshTokenResponse.success) {
    //       loginWithToken(refreshTokenResponse.value);
    //       router.push("/dashboard");
    //       return true;
    //     }
    //     else {
    //       logout();
    //       router.push("/login");
    //       return false;
    //     }
    //   }
    //   return false;
    // }

    return { login: setToken, logout, reset, loggedInUser, authenticated, token };
  },
  {
    persist: true,
  },
);
